import { resolve } from "inversify-react";
import * as React from "react";
import FileSystemService from "../../../services/filesystem.service";
import Fade from "react-reveal/Fade";
import { IImage } from "../../../typings";

export interface ImageFieldProps {
    id: string;
    className?: string;
    style?: React.CSSProperties;
    onLoad?: (uri: string) => void;
    noImage?: boolean;
    unconfirmed?: boolean;
}

export interface ImageFieldState {
    image?: IImage;
}

export default class ImageField extends React.Component<ImageFieldProps, ImageFieldState> {

    @resolve
    public fileSystemService: FileSystemService;

    constructor(props: ImageFieldProps) {
        super(props);

        this.state = {
        };
    }

    public componentDidMount() {
        if (this.props.id) {
            this.fileSystemService.getFile<IImage>(this.props.id).then((result) => {
                this.setState({image: result});
                if (this.props.onLoad) {
                    this.props.onLoad(result.image);
                }
            });
        }
    }

    public render() {
        const { unconfirmed } = this.props;
        let inner: any = null;
        if (!this.props.id) {
            inner = (
                <img
                    className={this.props.className}
                    style={this.props.style}
                    src="/static/images/no-image.jpg"
                />);
        } else {
            inner = (
                <img
                    key={this.props.id}
                    className={this.props.className}
                    style={this.props.style}
                    // @ts-ignore
                    src={window.SITE_CONFIG.baseUrl + "/api/image/" + this.props.id}
                />);
        }
        return (
            <Fade>
                <div className={unconfirmed ? "img-blur" : "img-back"}>
                    {inner}
                </div>
            </Fade>
        );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/data-component/data-image.tsx